<template>
    <div>
       <!-- <h1>AutomatOrNonAutomate</h1>   -->


       <div class="container mb-5"  >
       <b-button class="button is-large is-fullwidth"  type="is-success" outlined  @click="automateNonAutomateSelected(0)" >Automate</b-button>
       </div>

       <div class="container mt-5 mb-5"  >
        &nbsp;
       </div>

       <div class="container mt-5" >
       <b-button class="button is-large is-fullwidth"  type="is-success" outlined   @click="automateNonAutomateSelected(1)" >Non Automate</b-button>
       </div>
       
       

      
    </div>
</template>

<script>
export default {
    name : "AutomatOrNonAutomate",
    methods:{
       automateNonAutomateSelected(_selected){
           this.$emit('automateNonAutomateSelected',_selected)
       }
    }
}
</script>